// extracted by mini-css-extract-plugin
export default {"container":"CarouselIndicators_container__W+Bir","indicator":"CarouselIndicators_indicator__Ct3hn","active":"CarouselIndicators_active__ZYJ6F"};